import { Card, CardContent, CardHeader } from "../Card";
import { Skeleton } from "../Skeleton";

export function SalesReportChartSkeleton() {
	return (
		<CardContent className="flex flex-col gap-4">
			<div className="flex items-center justify-between">
				<Skeleton className="h-6 w-[120px]" />
				<Skeleton className="h-8 w-[200px]" />
			</div>
			<div className="h-[300px]">
				<Skeleton className="h-full w-full" />
			</div>
		</CardContent>
	);
}

export default function SalesReportSkeleton() {
	return (
		<Card className="flex-1">
			<CardHeader className="flex flex-row items-center justify-between pb-2">
				<Skeleton className="h-5 w-[120px]" />
				<Skeleton className="h-5 w-[100px]" />
			</CardHeader>

			<SalesReportChartSkeleton />
		</Card>
	);
}
